namespace TabAurous.OMS {
    export interface LabourPriceListDetailsRow {
        PriceListDetailsId?: number;
        PriceListId?: number;
        ProductId?: number;
        ItemType?: string;
        SubCategoryName?: string;
        AttributeId?: number;
        Attribute?: string;
        FromWt?: number;
        ToWt?: number;
        ProcessId?: number;
        FromDate?: string;
        ToDate?: string;
        PurStdRate?: number;
        SaleStdRate?: number;
        MarkUp?: number;
        Amount?: number;
        MinLabour?: number;
        ProcessName?: string;
        ProcessTypeId?: number;
        CalculateTo?: number;
        SettingId?: number;
        CalcOnId?: number;
        ItemTypeId?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
        IsCustomerItem?: boolean;
    }

    export namespace LabourPriceListDetailsRow {
        export const idProperty = 'PriceListDetailsId';
        export const localTextPrefix = 'OMS.LabourPriceListDetails';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            PriceListDetailsId = "PriceListDetailsId",
            PriceListId = "PriceListId",
            ProductId = "ProductId",
            ItemType = "ItemType",
            SubCategoryName = "SubCategoryName",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            FromWt = "FromWt",
            ToWt = "ToWt",
            ProcessId = "ProcessId",
            FromDate = "FromDate",
            ToDate = "ToDate",
            PurStdRate = "PurStdRate",
            SaleStdRate = "SaleStdRate",
            MarkUp = "MarkUp",
            Amount = "Amount",
            MinLabour = "MinLabour",
            ProcessName = "ProcessName",
            ProcessTypeId = "ProcessTypeId",
            CalculateTo = "CalculateTo",
            SettingId = "SettingId",
            CalcOnId = "CalcOnId",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date",
            IsCustomerItem = "IsCustomerItem"
        }
    }
}
